var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaceIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: 444444,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-120q-74.7 0-140.4-28.34t-114.3-76.92q-48.6-48.58-76.95-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.35 65.73 28.35 114.36 76.95 48.63 48.6 76.99 114.3Q840-554.7 840-480q0 27-3.77 53t-11.54 51q-7.84-6.77-16.73-12-8.88-5.23-19.34-7.69 6.07-20.39 8.73-41.27Q800-457.85 800-480q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93q54.08 0 102.47-16.62 48.4-16.62 88.99-46.53 6.62 7.77 14.12 14.61 7.5 6.85 16.73 11.54-46.39 36.38-102.52 56.69Q543.65-120 480-120Zm278.5-140q-12.58 0-21.31-8.69-8.73-8.68-8.73-21.27 0-12.58 8.69-21.31 8.69-8.73 21.27-8.73t21.31 8.69q8.73 8.68 8.73 21.27 0 12.58-8.69 21.31-8.68 8.73-21.27 8.73Zm-132.65-45.85L460-471.71V-680h40v191.69l154.15 154.16-28.3 28.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaceIc);
export default __webpack_public_path__ + "static/media/pace_ic.d9612dc0f77ee16fa09f640429a287d6.svg";
export { ForwardRef as ReactComponent };